module.exports = __webpack_public_path__ + "static/img/want-4.8969e829.png";